/* Publish by EComposer at 2026-10-15 13:14:39*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qanhp1qt13r"]=  window.__ectimmers["ecom-qanhp1qt13r"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),s=t.querySelector(".text-content.ecom-html");!s||(e&&e.addEventListener("click",()=>{s.classList.remove("ecom-text--is-mark"),s.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{s.classList.add("ecom-text--is-mark"),s.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-qanhp1qt13r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qanhp1qt13r', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddyqqmshlji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddyqqmshlji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6nj95rrpcuy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6nj95rrpcuy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lys3v9ezmrq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lys3v9ezmrq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0jyh0ug9u3s5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jyh0ug9u3s5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rd8mnbanite').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rd8mnbanite', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fz5kk5zp78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fz5kk5zp78', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5tnnj0vb6od').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5tnnj0vb6od', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09rp67cs036a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09rp67cs036a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ov1fkpfdmp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ov1fkpfdmp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jmxr6sv7wbk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jmxr6sv7wbk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1tjausmmizi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1tjausmmizi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvi0vtez56').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvi0vtez56', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qhmvd5u9etr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qhmvd5u9etr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iu12vrms6e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iu12vrms6e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljrlkxe3tt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljrlkxe3tt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-35php2tnwnn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-35php2tnwnn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jgo9k2i8eka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jgo9k2i8eka', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vy0s37as4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vy0s37as4e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xq0fa8dboj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xq0fa8dboj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3n5hrhzgub9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3n5hrhzgub9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gwicz2qr65v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gwicz2qr65v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5yjdpr9o4sh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5yjdpr9o4sh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dm68ncdqpee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dm68ncdqpee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0lwjj0ixyv7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0lwjj0ixyv7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vyk6b38rfid').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyk6b38rfid', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f92thesq594').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f92thesq594', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fey5bpji16j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fey5bpji16j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m2w731084s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m2w731084s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xbelz7p1sy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xbelz7p1sy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7l61yp4ung').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7l61yp4ung', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p4w2heh3o3g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p4w2heh3o3g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fa6rjuhmky9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fa6rjuhmky9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bad2i4xiyg4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bad2i4xiyg4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-29kxo0qxc0t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-29kxo0qxc0t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hqwr3bvbibn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hqwr3bvbibn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fs9hli24ove').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fs9hli24ove', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h1sjntlu6ro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h1sjntlu6ro', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r6p0oxqvly9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r6p0oxqvly9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7tunw3gif9k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7tunw3gif9k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22gtajstl8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22gtajstl8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ws1tx4z2yno').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ws1tx4z2yno', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zd8sym2fsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zd8sym2fsa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ux6ke66l0lc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ux6ke66l0lc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-riht40ed6ea').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-riht40ed6ea', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzhdm1w07od').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzhdm1w07od', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uct1quftug9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uct1quftug9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iz7l4n9ugc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iz7l4n9ugc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-21qaxu3r73y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-21qaxu3r73y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9csflv918sf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9csflv918sf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e7huiyu0rc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e7huiyu0rc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jipedqx1cxo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jipedqx1cxo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ojao0nac7bi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ojao0nac7bi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k8xqq8h4bbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k8xqq8h4bbj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m7p29wue0d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m7p29wue0d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iygot8tr1x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iygot8tr1x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dhpu32650z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dhpu32650z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wv1bqzt1cnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wv1bqzt1cnh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8tsf219ngma').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8tsf219ngma', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tz4bcuqoav').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tz4bcuqoav', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8az95ifxfu7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8az95ifxfu7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j6ndksv83qc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j6ndksv83qc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zbctreneqt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zbctreneqt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3f8vrbmmaw8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3f8vrbmmaw8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v9s08tg8lp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v9s08tg8lp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-65hqpbut6q7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-65hqpbut6q7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8noevmnygah').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8noevmnygah', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oaonautr6ue').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oaonautr6ue', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yzl8a9j8gbe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yzl8a9j8gbe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8xbr7z1n0fk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8xbr7z1n0fk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0oe0wwqc36qh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0oe0wwqc36qh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ytfbpy6ti5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ytfbpy6ti5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pmtvzohu18j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pmtvzohu18j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yqfyv274nlh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yqfyv274nlh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-etowil53cu4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-etowil53cu4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tewvrmd0psi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tewvrmd0psi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3l1s7s6ignh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3l1s7s6ignh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zhzf6zv8gce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zhzf6zv8gce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h2diuojd2k8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h2diuojd2k8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ghzamlt0hye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ghzamlt0hye', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bids9ss70gs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bids9ss70gs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s1vp4r93plg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s1vp4r93plg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sjm373on8v8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sjm373on8v8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mdt4k5r5f8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mdt4k5r5f8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g5zx5ynlbbj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g5zx5ynlbbj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jmk1sj23k9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jmk1sj23k9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7rlda3dv2h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7rlda3dv2h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e22bcuffqgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e22bcuffqgi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1hphgxt7g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1hphgxt7g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r6sutqm4t0n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r6sutqm4t0n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvvny2tl4z').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvvny2tl4z', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7dti9pdvyu9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7dti9pdvyu9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0zbakgqespy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0zbakgqespy', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sdznl3mtrze').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sdznl3mtrze', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxlblakh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxlblakh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-loitsd61s7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-loitsd61s7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u1ezksz1p3b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u1ezksz1p3b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2unw12muii').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2unw12muii', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ovq1j10fes"]=  window.__ectimmers["ecom-ovq1j10fes"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const s=t.querySelector(".ecom__element--button");if(!s)return;let o=parseInt(i.settings.animation_loop_time)*1e3||6e3,n=1e3;window.__ectimmers["ecom-ovq1j10fes"]["jc277vf09"] = setInterval(function(){s.classList.add("animated"),setTimeout(function(){s.classList.remove("animated")},n)},o)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let s=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const o=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},s);try{Shopify.analytics.publish("ec_custom_events",o)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const n=e.getAttribute("href"),r=e.getAttribute("target");n&&n!=="#"&&n!=="javascript:void(0)"&&(r==="_blank"?window.open(n,"_blank"):setTimeout(function(){window.location.href=n},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-ovq1j10fes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ovq1j10fes', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urqklxabzza').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urqklxabzza', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vkrulqf58bp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vkrulqf58bp', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-p0sr8pl5i19').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-p0sr8pl5i19', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o7yjdl8qjfk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o7yjdl8qjfk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-krc4xcyxsu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-krc4xcyxsu', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-do2gp3vjfit').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-do2gp3vjfit', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xdwn5iky26').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xdwn5iky26', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gzej8ju0kxc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gzej8ju0kxc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xltzs4ohfd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xltzs4ohfd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s3vb1dl0ucr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s3vb1dl0ucr', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7kqmumcs8sq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7kqmumcs8sq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1bu3p86cfoi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1bu3p86cfoi', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9s0t041o04s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9s0t041o04s', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kr0ofwd8qc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kr0ofwd8qc', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mk9oqlwgujd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mk9oqlwgujd', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ftiuxgjnvkq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ftiuxgjnvkq', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-le4wud84pe8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-le4wud84pe8', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uco6cp5r9vl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uco6cp5r9vl', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qnx9sp9vxz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qnx9sp9vxz', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-srvocv303n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-srvocv303n', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rl7maocapk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rl7maocapk', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zvnxh7g21x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zvnxh7g21x', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-woxd7472xn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-woxd7472xn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3osno8fpyxn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3osno8fpyxn', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kdw41qno35b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kdw41qno35b', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tcl9w2igo08').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tcl9w2igo08', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ae283srpsq6"]=  window.__ectimmers["ecom-ae283srpsq6"] || {};
var $,E,A,j,P,T;let t=this.$el;if(!t)return;let e=this.isLive;const i=($=this.settings.disable_auto_close)!=null?$:!1,s=(E=this.settings.disable_auto_close__tablet)!=null?E:!1,o=(A=this.settings.disable_auto_close__mobile)!=null?A:!1,n=(j=this.settings.scroll_on_mobile)!=null?j:!1,r=(P=this.settings.disable_effect)!=null?P:!1,a=(T=this.settings.close_all)!=null?T:!1,l=t.querySelector(":scope > .core__group--wrapper > .core__group--items"),c=l?l.querySelectorAll(":scope > .ecom-accordion__item"):[],d=Array.from(c).map(I=>I.querySelector(":scope > .ecom-accordion__title")).filter(Boolean);function p(I){const D=I.getBoundingClientRect();return D.top>=0&&D.left>=0&&D.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&D.right<=(window.innerWidth||document.documentElement.clientWidth)}function m(){return window.EComposer.TEMPLATE_ID?window.screen.width:window.innerWidth}function _(I){return o&&I<768||s&&I>767&&I<1025||i&&I>1024}function b(I){if(!I)return;const D=I.style.transition;I.style.transition="none",I.style.height="auto";const R=I.scrollHeight;I.style.height="0px",I.offsetHeight,I.style.transition=D,requestAnimationFrame(()=>{const H=r?"auto":e?R+"px":"auto";I.style.height=H})}function y(I){I.classList.remove("ecom-item-active");const D=I.querySelector(":scope > .ecom-accordion__body");D&&(r||(D.style.height=D.scrollHeight+"px",D.offsetHeight),requestAnimationFrame(()=>{D.style.height="0px"}))}function v(I){let D=0;if(I.offsetParent)do D+=I.offsetTop;while(I=I.offsetParent);return D}function w(I){const D=Math.max(0,I),R=window.pageYOffset||document.documentElement.scrollTop,H=D-R;if(H===0)return;const K=300;let V=null;function G(te){V||(V=te);const ne=Math.min((te-V)/K,1),Y=ne<.5?2*ne*ne:1-Math.pow(-2*ne+2,2)/2;window.scrollTo(0,R+H*Y),ne<1&&window.requestAnimationFrame(G)}window.requestAnimationFrame(G)}function z(I){w(v(I)-100)}function C(I,D=!1){I.forEach((R,H)=>{const K=R.parentNode,V=K.querySelector(":scope > .ecom-accordion__body");!r&&V&&V.classList.add("ecom-effect-accodion");const G=K.classList.contains("ecom-item-active");V&&!a&&(D&&H===0||G)&&requestAnimationFrame(()=>{V.style.height=V.scrollHeight+"px"}),R.onclick=function(te){var pe,_e;if(te.preventDefault(),!e){window.dispatchEvent(new window.Event("renderScroll"));return}const ne=m(),Y=this.parentNode,he=Y.parentNode,ce=he.querySelectorAll(":scope > .ecom-accordion__item"),ue=Array.from(ce).map(we=>we.querySelector(":scope > .ecom-accordion__title")).filter(Boolean),J=Y.querySelector(":scope > .ecom-accordion__body");Y.classList&&Y.classList.remove("ecom-item-group-init");const U=this.classList.contains("ecom-item-active"),X=_(ne);if(U)X?(this.classList.remove("ecom-item-active"),Y.classList.remove("ecom-item-active"),y(Y)):(ce.forEach(y),ue.forEach(we=>we.classList.remove("ecom-item-active")));else{X||(ce.forEach(y),ue.forEach(Ae=>Ae.classList.remove("ecom-item-active"))),R.classList.add("ecom-item-active"),Y.classList.add("ecom-item-active");let we=Y.closest(".ecom-accordion__body");for(;we;)we.style.height="auto",we=(_e=(pe=we.parentElement)==null?void 0:pe.closest)==null?void 0:_e.call(pe,".ecom-accordion__body");!r&&J&&J.classList.add("ecom-effect-accodion"),b(J)}window.dispatchEvent(new window.Event("renderScroll"));const ee=this,ge=n||ne>1024;function Q(){window.dispatchEvent(new window.Event("renderScroll")),ge&&!p(ee)&&z(ee)}if(ge&&!r){let we;const Ae=function(Te){Te.propertyName==="height"&&(clearTimeout(we),we=setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},50))};he.addEventListener("transitionend",Ae),setTimeout(()=>{he.removeEventListener("transitionend",Ae),Q()},600)}else requestAnimationFrame(()=>{setTimeout(Q,100)})}})}C(d,!0),a||requestAnimationFrame(()=>{const I=t.querySelector(".ecom-item-group-init");I&&I.classList.remove("ecom-item-group-init")});function S(){const I=window.location.hash;if(I){const D=t.querySelector(`[data-target="${I}"]`);if(D){D.click(),D.dispatchEvent(new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window}));const K=D.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;w(K)}}}requestAnimationFrame(()=>{setTimeout(S,100)}),window.addEventListener("resize",()=>C(d)),window.addEventListener("hashchange",S,!1)

                    });
                    
                        document.querySelectorAll('.ecom-ae283srpsq6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ae283srpsq6', settings: {"disable_auto_close":false,"disable_auto_close__tablet":true,"disable_effect":false,"close_all":true},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-feantbg5227"]=  window.__ectimmers["ecom-feantbg5227"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-feantbg5227"]["rcv5rm6ks"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let s=this.$el;if(!s)return;function o(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let r=s.querySelector(".ecom-element.ecom-base-image"),a=s.closest(".core__row--columns");r&&(o(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-feantbg5227').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-feantbg5227', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hop1n7esqdg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hop1n7esqdg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gm8jqb36lst').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gm8jqb36lst', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vgv9lw904wn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vgv9lw904wn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mf245lsjcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mf245lsjcn', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r66j5qh9zsl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r66j5qh9zsl', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9mfl75ae04').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9mfl75ae04', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uoll8wccn7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uoll8wccn7', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g8yuaw5bdxv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g8yuaw5bdxv', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wr378dsh0t9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wr378dsh0t9', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ljb19ru95j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ljb19ru95j', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-351a63uqi4g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-351a63uqi4g', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j3aifk0jeq8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j3aifk0jeq8', settings: {"link":"custom","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}